import lifecycle from './partials/commons/lifecycle'
import header from './partials/commons/header'